<template>
  <div class="icon-content">
    <img class="icon-tip" :src="appData.agentLogoUrl" />

    <div class="center-tip">
      <span>您还未绑定设备，</span>
      <span class="center-item">可帮助其他设备进行充值！</span>
    </div>

    <div class="buy-button" @click="addDeviceAction">立即充值</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {
    addDeviceAction() {
      this.uni.navigateTo("/home/associationDevice");
    },
  },
};
</script>

<style lang="less" scoped>
.icon-content {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding-top: 126px;
  justify-content: flex-start;
  align-items: center;

  .icon-tip {
    width: 136px;
    height: 136px;
  }

  .center-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #666;
    font-size: 36px;
    margin-top: 55px;
    .center-item {
      padding-top: 16px;
    }
  }

  .buy-button {
    background-color: var(--primary-color);
    color: #fff;
    font-size: 32px;
    margin-top: 150px;
    width: calc(100vw - 80px);
    height: 90px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    // touch-action: manipulation;
    user-select: none;
    transition: opacity 0.2s ease;
    &:active {
      opacity: 0.9;
    }
  }
}
</style>
